import { render, staticRenderFns } from "./PaymentMpnContent.vue?vue&type=template&id=9af6d7c2&lang=pug"
import script from "./PaymentMpnContent.vue?vue&type=script&lang=js"
export * from "./PaymentMpnContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports